"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const nav_1 = require("components/cosmos/nav");
const grid_1 = require("components/grid");
const gridContainer_1 = require("components/gridContainer");
const translate_1 = require("components/translate");
const constants_1 = require("configs/routes/constants");
const useShellContext_1 = require("hooks/useShellContext");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const isUndefined_1 = __importDefault(require("lodash/isUndefined"));
const mobx_react_1 = require("mobx-react");
const class_1 = require("modules/app/services/datahub/class");
const constants_2 = require("modules/app/services/ga/constants");
const GtagService_1 = __importDefault(require("modules/app/services/ga/GtagService"));
const ContentBasePage_1 = __importDefault(require("modules/content/components/ContentBasePage"));
const featureToggle_1 = require("modules/featureToggle");
const ClassContent_1 = __importDefault(require("./classContent/ClassContent"));
const ClassService_1 = __importDefault(require("./ClassService"));
const ClassTabsUtil_1 = require("./ClassTabsUtil");
const ClassUsers_1 = __importDefault(require("./classUsers/ClassUsers"));
const constants_3 = require("./constants");
const modules_1 = require("./modules");
require("./ClassManager.scss");
const ClassManager = ({ t, totalUsersMap, isAddClassModuleFeatureEnabled = false }) => {
    var _a;
    const { isMembership } = (0, useShellContext_1.useShellContext)();
    const history = (0, react_router_dom_1.useHistory)();
    const match = (0, react_router_dom_1.useRouteMatch)();
    const classId = ((_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a.id) || '0';
    const totalUsers = totalUsersMap.get(classId);
    const isTotalUsersFetched = !(0, isUndefined_1.default)(totalUsers);
    const shouldRenderUsersTab = Boolean(totalUsers && totalUsers > 0);
    const defaultTab = (0, ClassTabsUtil_1.getTabByParamName)({
        tabName: match.params.tabName || '',
        isUsersTabEnabled: shouldRenderUsersTab,
        isAddClassModuleFeatureEnabled
    });
    const [currentTab, setCurrentTab] = (0, react_1.useState)(defaultTab);
    const handleBack = () => history.push(constants_1.ROUTES.CLASS.LIST);
    const tabs = [
        {
            labelTitle: 'class_manager.class_editor.tabs.general',
            tab: ClassTabsUtil_1.Tabs.General,
            component: (0, jsx_runtime_1.jsx)(ClassContent_1.default, { classId: classId }),
            classCategory: class_1.ClassCategory.ClickOnGeneralTab
        },
        {
            labelTitle: 'class_manager.class_editor.tabs.main_modules',
            tab: ClassTabsUtil_1.Tabs.MainModules,
            component: (0, jsx_runtime_1.jsx)(modules_1.Modules, { classId: classId }),
            classCategory: class_1.ClassCategory.ClickOnMainModulesTab,
            shouldRenderComponent: isAddClassModuleFeatureEnabled
        },
        {
            labelTitle: 'class_manager.class_editor.tabs.additional_modules',
            tab: ClassTabsUtil_1.Tabs.ExtraModules,
            component: (0, jsx_runtime_1.jsx)(modules_1.Modules, { classId: classId, isExtraModule: true }),
            classCategory: class_1.ClassCategory.ClickOnExtraModulesTab,
            shouldRenderComponent: isAddClassModuleFeatureEnabled
        },
        {
            labelTitle: 'class_manager.class_users_title',
            tab: ClassTabsUtil_1.Tabs.Users,
            component: (0, jsx_runtime_1.jsx)(ClassUsers_1.default, { backHandler: handleBack, classId: classId }),
            classCategory: class_1.ClassCategory.ClickOnUsersTab,
            shouldRenderComponent: shouldRenderUsersTab,
            track: 'Users'
        }
    ];
    (0, react_1.useEffect)(() => {
        const fetchUsers = async () => {
            if (!isTotalUsersFetched) {
                await ClassService_1.default.fetchTotalUsersMapByClasses([classId]);
            }
        };
        fetchUsers();
    }, [isTotalUsersFetched, classId]);
    const handleTabChange = (tab, classCategory, track) => {
        setCurrentTab(tab);
        if (classId) {
            class_1.DatahubClassService.sendClassTabGroupViewEvent({
                classId,
                category: classCategory
            });
        }
        if (track) {
            GtagService_1.default.sendPageEvent({
                subsection: constants_1.PAGE_VIEW_EVENTS.BROADCAST.NEW,
                subsection2: track,
                sourceType: constants_2.SOURCE_TYPES.ONLINE_COURSE
            });
        }
    };
    return (isTotalUsersFetched && ((0, jsx_runtime_1.jsx)("div", { className: "class-manager-wrapper content__grid", children: (0, jsx_runtime_1.jsx)(grid_1.Grid, { block: true, transparent: true, noborder: true, nopadding: isMembership, children: (0, jsx_runtime_1.jsx)(gridContainer_1.GridContainer, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "class_manager__back_button", children: (0, jsx_runtime_1.jsx)(ContentBasePage_1.default.Header, { title: t(constants_3.CLASS_FORM_TITLE.EDIT, { checkOnlineEvent: true }), isTitleLabel: false, backHandler: handleBack }) }), (0, jsx_runtime_1.jsx)(nav_1.Nav, { className: "_mb-5", children: tabs
                                .filter((tab) => { var _a; return (_a = tab.shouldRenderComponent) !== null && _a !== void 0 ? _a : true; })
                                .map(({ labelTitle, classCategory, track, tab }) => {
                                const isActive = currentTab === tab;
                                return ((0, jsx_runtime_1.jsx)(nav_1.Nav.Item, { active: isActive, className: "_d-flex _align-items-center _mr-2 _p-0 _h-8", children: (0, jsx_runtime_1.jsx)("button", { className: "bg-transparent _border-0 _py-3 _px-4", onClick: () => handleTabChange(tab, classCategory, track), children: t(labelTitle) }) }, labelTitle));
                            }) }), (0, jsx_runtime_1.jsx)("div", { children: tabs[currentTab].component }, currentTab)] }) }) }) })));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)(({ ClassStore, FeatureToggleStore }) => {
    var _a;
    return ({
        totalUsersMap: ClassStore.totalUsersMap,
        isAddClassModuleFeatureEnabled: (_a = FeatureToggleStore === null || FeatureToggleStore === void 0 ? void 0 : FeatureToggleStore.featureToggles) === null || _a === void 0 ? void 0 : _a.get(featureToggle_1.FeatureToggles.AddClassModules)
    });
}))(ClassManager);
